import React, { forwardRef } from 'react';
import { LucideIcon } from 'lucide-react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    icon?: LucideIcon;
    fullWidth?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({
    label,
    error,
    icon: Icon,
    fullWidth = false,
    className = '',
    ...props
}, ref) => {
    const baseStyles = 'block rounded-md bg-dark-900 border border-dark-600 text-dark-100 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 disabled:opacity-50 disabled:cursor-not-allowed';
    const width = fullWidth ? 'w-full' : '';
    const padding = Icon ? 'pl-10 pr-3' : 'px-3';

    return (
        <div className={fullWidth ? 'w-full' : ''}>
            {label && (
                <label className="block mb-1 text-sm font-medium text-dark-200">
                    {label}
                </label>
            )}
            <div className="relative">
                {Icon && (
                    <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                        <Icon className="w-5 h-5 text-dark-500" />
                    </div>
                )}
                <input
                    ref={ref}
                    className={`${baseStyles} ${padding} ${width} py-2 ${className} ${error ? 'border-red-600 focus:ring-red-500 focus:border-red-500' : ''}`}
                    {...props}
                />
            </div>
            {error && (
                <p className="mt-1 text-sm text-red-500">{error}</p>
            )}
        </div>
    );
});

Input.displayName = 'Input';

export default Input;